import React from 'react';
import { ArrowLeft, Camera, Palette, ShoppingCart, User, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = ({ showBackButton = false, cartCount = 0 }) => {
    const navigate = useNavigate();

    return (
        <header className="bg-white/80 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-orange-200">
            <div className="w-full px-4 lg:px-8 py-4 lg:py-5 flex justify-between items-center">
                {showBackButton ? (
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-orange-600 transition-colors"
                    >
                        <ArrowLeft size={18} />
                        <span className="text-sm">Back</span>
                    </button>
                ) : (
                    <div className="flex items-center gap-3">
                        <Camera className="text-orange-500" size={20} />
                        <Palette className="text-amber-500" size={20} />
                    </div>
                )}

                <div className="text-center">
                    <h1
                        className="text-2xl lg:text-4xl font-bold bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent cursor-pointer"
                        onClick={() => navigate('/template20')}
                    >
                        STUDIO
                    </h1>
                    <p className="text-xs lg:text-sm text-gray-500 tracking-widest">CREATIVE COLLECTIVE</p>
                </div>

                <div className="flex items-center gap-3">
                    <Heart className="text-orange-500 cursor-pointer hover:text-orange-600 transition-colors" size={20} />
                    <div className="relative cursor-pointer" onClick={() => navigate('/template20/cart')}>
                        <ShoppingCart className="text-orange-500 hover:text-orange-600 transition-colors" size={20} />
                        {cartCount > 0 && (
                            <span className="absolute -top-2 -right-2 bg-gradient-to-r from-orange-500 to-amber-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                                {cartCount}
                            </span>
                        )}
                    </div>
                    <User className="text-orange-500 cursor-pointer hover:text-orange-600 transition-colors" size={20} onClick={() => navigate('/template20/profile')} />
                </div>
            </div>
        </header>
    );
};

export default Header;
